export const environment = {
  name: 'develop',
  production: false,
  apiUrl: 'https://accountsdev-bff.ucc.edu.ar/api/v1',
};
